(function ($) {
  $('.js-load-all-jobs').on('click', function (e) {
    e.preventDefault();
    var $t = $(this);
    var country = $('#country').val();
    var job_type = $('#job_type').val();
    var data = {
      action: 'load-all-jobs',
      country: country,
      job_type: job_type,
    };

    // disable button
    $(this).prop('disabled', true);

    //change it on ajax loading
    $(this).text('...');

    $.ajax({
      type: 'GET',
      url: GLOBAL.ajax,
      data: data,
      success: function (data) {
        if (data.success === true) {
          $('.js-jobs-append').append($(data.data).slideDown());
        }
        $t.hide();
      },
    });
  });

  $('.js-load-all-awards').on('click', function (e) {
    var $t = $(this);
    var country = $('#country').val();
    var year = $('#award-year').val();

    var data = {
      action: 'load-all-awards',
      country: country,
      'award-year': year,
    };

    // disable button
    $(this).prop('disabled', true);

    //change it on ajax loading
    $(this).text('...');

    $.ajax({
      type: 'GET',
      url: GLOBAL.ajax,
      data: data,
      success: function (data) {
        if (data.success === true) {
          $('.js-awards-append').append($(data.data));
        }
        $t.hide();
      },
    });
  });
})(jQuery);
